export default __webpack_public_path__ + "static/media/distribution.b6a17268.svg";